
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// Base URLs for Microservices (pointing to Gateway)
export const baseUrlAccount = `${API_BASE}/api/clients/`; // Map to /api/clients in gateway
export const baseUrlTransactions = `${API_BASE}/api/transactions/`; // Map to /api/transactions in gateway

// Fallback or specific monolith URL if needed
// export const baseUrlMonolith = 'http://localhost:8000/api/'; 
